import type { FC, ReactNode } from "react";
import { Redirect } from "react-router-dom";
import { PATH_SUPERADMIN } from "src/routesConstants";
import { isPageAllowed } from "src/utils/pageAccess";
import { isAdminUser } from "src/utils/permission";
import useAuth from "../hooks/useAuth";
import { isUserEnabled } from "../utils/shouldDisplayEntity";

interface AuthGuardNotAdminProps {
    children?: ReactNode;
}

const AuthGuardNotAdmin: FC<AuthGuardNotAdminProps> = ({ children }) => {
    const { isAuthenticated, user } = useAuth();

    if (!isAuthenticated || (user && !isUserEnabled(user))) {
        return <Redirect to="/login" />;
    }
    if (isAdminUser(user)) {
        return <Redirect to={PATH_SUPERADMIN} />;
    }

    if (!isPageAllowed({ user, path: window.location.pathname })) {
        return <Redirect to="/404" />;
    }

    return <>{children}</>;
};

export default AuthGuardNotAdmin;
